<main id="code" class="info">
    <div id="background"></div>
    <header>
        <header-component></header-component>
        <div class="nav">
            <h1>
                {{ app.checkedin ? _('code_title_after_checkedin') :
                _('code_title') }}
            </h1>
            <span class="icon back" @click="app.setPage('Terminal')">
                chevron_left
            </span>
        </div>
    </header>

    <section>
        <img class="qr_code_img" :src="app.checkin_qrcode" />
        <div><span>{{_('code')}}</span>：{{app.code}}</div>
    </section>

    <div class="qr-description">
        <h2>{{_('code_description_title')}}</h2>
        <p>
            {{_('code_description', app.checkedin ? _('checkout') :
            _('checkin'))}}
        </p>
        <p v-if="app.display_checkout_button && app.checkedin">
            {{_('checkout_button_description')}}
        </p>
    </div>
    <div
        v-if="app.display_checkout_button && app.checkedin"
        class="checkout-btn-wrapper"
    >
        <button class="checkout_procedure" @click="app.setPage('Checkout')">
            {{_('checkout_procedure')}}
        </button>
    </div>
    <tab-bar :page="app.query.page"></tab-bar>
</main>
